module.exports = __webpack_public_path__ + "img/tj-logo_horizontal.707ec805.svg";